export default __webpack_public_path__ + "static/media/hmd_m3.ee1d47af.png";